import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  APIConnectionsModal,
  APIConnectionsFilter,
  APIConnectionsListing,
  ConnectionDetailsbyId,
  APIConnectionsListingQueryParameters,
} from "./type";

export const APIConnectionsInitialstate: APIConnectionsModal = {
  connectionsListing: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },

  connectionsListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchKey: "",
  },

  apiConnectionsFilter: {
    fromAddedOnDate: null,
    toAddedOnDate: null,
  },

  connectionDetails: {
    state: "",
    apiKey: "",
    secretKey: "",
    companyName: "",
    externalSoftware: "",
  },

  dateRangeForAddedOn: undefined,
};

const APIConnectionsModuleSlice = createSlice({
  name: "api-connections",
  initialState: APIConnectionsInitialstate,
  reducers: {
    setAPIConnectionsListingData: (
      state: APIConnectionsModal,
      action: PayloadAction<APIConnectionsListing>,
    ) => {
      state.connectionsListing = { ...action.payload };
    },
    setAPIConnectionsListingQueryParameters: (
      state: APIConnectionsModal,
      action: PayloadAction<APIConnectionsListingQueryParameters>,
    ) => {
      state.connectionsListingQueryParameters = { ...action.payload };
    },
    setDateRangeForAddedOn: (
      state: APIConnectionsModal,
      action: PayloadAction<[Date, Date] | undefined>,
    ) => {
      state.dateRangeForAddedOn = action.payload;
    },
    setAPIConnectionsFilter: (
      state: APIConnectionsModal,
      action: PayloadAction<APIConnectionsFilter>,
    ) => {
      state.apiConnectionsFilter = action.payload;
    },

    setAPIConnectionDetails: (
      state: APIConnectionsModal,
      action: PayloadAction<ConnectionDetailsbyId>,
    ) => {
      state.connectionDetails = action.payload;
    },
  },
});

export const {
  setDateRangeForAddedOn,
  setAPIConnectionsFilter,
  setAPIConnectionDetails,
  setAPIConnectionsListingData,
  setAPIConnectionsListingQueryParameters,
} = APIConnectionsModuleSlice.actions;
export default APIConnectionsModuleSlice.reducer;
